var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.count > 1 && !_vm.sample
      ? _c(
          "div",
          { staticClass: "filters-frame" },
          _vm._l(_vm.categories, function(c) {
            return _c(
              "a",
              {
                staticClass: "button mod-filter",
                class: { active: _vm.catID === c.cat_ID },
                attrs: { href: "#" },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.setActive(c.cat_ID)
                  }
                }
              },
              [_vm._v(_vm._s(c.name))]
            )
          }),
          0
        )
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "blog-posts-frame" },
      [
        _vm._l(_vm.display, function(d) {
          return _c("article", { key: d.id, staticClass: "blog-post" }, [
            d.acf.header_image
              ? _c("a", {
                  staticClass: "blog-post-img",
                  style: {
                    backgroundImage:
                      "url(" + d.acf.header_image.sizes.medium_large + ")"
                  },
                  attrs: { href: d.link }
                })
              : _c("a", {
                  staticClass: "blog-post-img",
                  style: { backgroundImage: "url(" + d.thumb + ")" },
                  attrs: { href: d.link }
                }),
            _vm._v(" "),
            _c("div", { staticClass: "blog-post-excerpt" }, [
              _c("div", [
                _c("a", { attrs: { href: d.link } }, [
                  _c("h4", [_vm._v(_vm._s(d.post_title))])
                ]),
                _vm._v(" "),
                _c("p", [_vm._v(_vm._s(d.acf.excerpt))]),
                _vm._v(" "),
                _c("div", { staticClass: "blog-post-excerpt-sub" }, [
                  _vm._v(_vm._s(d.author) + " |")
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "blog-post-excerpt-sub" }, [
                  _vm._v(_vm._s(_vm.niceDate(d.post_date)))
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "blog-post-excerpt-sub mod-category" },
                  _vm._l(d.categories, function(c) {
                    return c.term_id != 1
                      ? _c("span", [_vm._v(_vm._s(c.name))])
                      : _vm._e()
                  }),
                  0
                )
              ]),
              _vm._v(" "),
              _c(
                "a",
                { staticClass: "button mod-readmore", attrs: { href: d.link } },
                [_vm._v("Read More")]
              )
            ])
          ])
        }),
        _vm._v(" "),
        _c("div", { staticClass: "loader", class: { loading: _vm.loading } }, [
          _vm._m(0)
        ])
      ],
      2
    ),
    _vm._v(" "),
    _vm.isMore && !_vm.sample
      ? _c(
          "div",
          { staticClass: "page-action", class: { hidden: _vm.loading } },
          [
            _c(
              "a",
              {
                staticClass: "button mod-load-more active",
                attrs: { href: "#", rel: "nofollow" },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.loadMore()
                  }
                }
              },
              [_vm._v("Load a few more")]
            )
          ]
        )
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "spinner" }, [
      _c("div", { staticClass: "double-bounce1" }),
      _vm._v(" "),
      _c("div", { staticClass: "double-bounce2" })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }